import ProjectPresetsDefinerFormComponent from './definer-form.component'

export default ProjectPresetsDefinerFormComponent
